module.exports = __webpack_public_path__ + "static/media/contact-illustration-min.3b48acfa.webp";